/**
 * Information from Arkansas Smoke Management Infobook Rev 2020:
 * https://www.agriculture.arkansas.gov/wp-content/uploads/2020/09/SmokeMngment_INFOBOOK_REV2020.pdf 
 * 
 * Max Tons of fuel allocated to an airshed based on distance from closest SSA and category day.
 * Format:
 * Array<
 *	{
		distanceToSSA: [minDistance, maxDistance], // in miles
		tonsOfFuel: [
			max tons for category day 1,
			max tons for category day 2,
			max tons for category day 3,
			max tons for category day 4,
			max tons for category day 5,
		]
	 } 
 * >
 */
export const maxTonsFuelAllocations = [
	{
		distanceToSSA: [0, 0.19],
		tonsOfFuel: [0,0,0,0,0]
	},
	{
		distanceToSSA: [0.2,4.9],
		tonsOfFuel: [0,488, 560, 720, 1280]
	},
	{
		distanceToSSA: [5, 9.9],
		tonsOfFuel: [0,1000,1200, 1840, 3200]
	},
	{
		distanceToSSA: [10, 19.9],
		tonsOfFuel: [0,1840, 2240, 4200, 7200]
	},
	{
		distanceToSSA: [20, Number.POSITIVE_INFINITY],
		tonsOfFuel: [0,2880, 3280, 6400, 11600]
	},
]



/**
 * {
 * 	name: <name of crop or forestry>,
 * 	fuelLoadingRange: [Low range, Medium range, Heavy range] <unit: tons / acre>,
 * 	fuelLoadingDescription: [low,medium,heavy] 
 * }
 */

export const crops = [
	{
		name: 'Corn',
		fuelLoadingRange: [3.1, 4.7, 6.2],
		fuelLoadingDescription: ['121 bushels per acre', '180 bushels per acre', '240 bushels per acre']
	},
	{
		name: 'Cotton',
		fuelLoadingRange: [.8, 1.1, 1.5],
		fuelLoadingDescription: ['750 pounds per acre', '1121 pounds per acre', '1491 pounds per acre']
	},
	{
		name: 'Soybean',
		fuelLoadingRange: [2.9, 4.3, 5.7],
		fuelLoadingDescription: ['32 bushels per acre', '48 bushels per acre', '64 bushels per acre']
	},
	{
		name: 'Wheat',
		fuelLoadingRange: [.9, 1.4, 1.9],
		fuelLoadingDescription: ['38 bushels per acre', '57 bushels per acre', '76 bushels per acre']
	},
	{
		name: 'Rice',
		fuelLoadingRange: [2.5, 3.7, 4.9],
		fuelLoadingDescription: ['109 bushels per acre', '163 bushels per acre', '217 bushels per acre']
	}
];

export const forestry = [
	{
		name: 'Dispersed Slash',
		fuelLoadingRange: [4, 6, 8],
		fuelLoadingDescription: ['less than 2 years since last burn', '2 to 5 years since last burn', '6 years or more since last burn']
	},
	{
		name: 'Grass/Brush',
		fuelLoadingRange: [2, 3, 5],
		fuelLoadingDescription: ['less than 2 years since last burn', '2 to 5 years since last burn', '6 years or more since last burn']
	},
	{
		name: 'Hardwood Leaf Litter',
		fuelLoadingRange: [.8, 1.5, 2.5],
		fuelLoadingDescription: ['less than 2 years since last burn', '2 to 5 years since last burn', '6 years or more since last burn']
	},
	{
		name: 'Loblolly Pine Regeneration',
		fuelLoadingRange: [4.4, 7.6, 8.5],
		fuelLoadingDescription: ['less than 2 years since last burn', '2 to 5 years since last burn', '6 years or more since last burn']
	},
	{
		name: 'Loblolly Pine with Oak',
		fuelLoadingRange: [6.4, 6.8, 7.9],
		fuelLoadingDescription: ['less than 2 years since last burn', '2 to 5 years since last burn', '6 years or more since last burn']
	},
	{
		name: 'Piled Debris',
		fuelLoadingRange: [5, 7.5, 10],
		fuelLoadingDescription: ['less than 2 years since last burn', '2 to 5 years since last burn', '6 years or more since last burn']
	},
	{
		name: 'Shortleaf Pine Regeneration',
		fuelLoadingRange: [2.6, 3.8, 5.1],
		fuelLoadingDescription: ['less than 2 years since last burn', '2 to 5 years since last burn', '6 years or more since last burn']
	},
	{
		name: 'Shortleaf Pine with Oak',
		fuelLoadingRange: [1.5, 3.8, 5.9],
		fuelLoadingDescription: ['less than 2 years since last burn', '2 to 5 years since last burn', '6 years or more since last burn']
	}
]

/**
 * Array containing burn guidelines based on category day.
 * Array index+1 represents the category day.
 */
export const burnGuidelinesByCategoryDay = [
	'Daytime burning only, between 11 AM and 4 PM, maximum of 100 acres, and not before surface inversion has lifted. No burning of heavy fuel loads.', //Cat day 1
	'No burning until 11 AM and not before surface inversion.',
	'Burn only after surface inversion has lifted.',
	'Burn anytime.',
	'“Unstable” and windy. Excellent smoke dispersal. Burn with caution.' //cat day 5
]